import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Navigation from "../shell/sidebar/Navigation";
import { Bars, CrossIcon } from "../icons";
import { usePageState } from "../context/usePageState";

export interface PageMenuProps {
  /** Just the logo: no menu, and nothing to open one with. */
  logoOnly?: boolean;
}

export function PageMenu({ logoOnly = false }: PageMenuProps) {
  const {
    menuOpen,
    toggleMenu,
    mobileMenuOpen,
    openMobileMenu,
    closeMobileMenu,
    menuItems,
    expandedSectionId,
    expandedSubSectionId,
    toggleSection,
    toggleSubSection,
  } = usePageState();

  if (logoOnly) {
    return (
      <div id="logo-bar">
        <span id="logo">
          <img
            alt="Jonas Sports"
            src={process.env.PUBLIC_URL + "/jonas-sports-logo-reversed.svg"}
          />
        </span>
      </div>
    );
  }

  return (
    <>
      {!mobileMenuOpen && (
        <div
          id="sidebar-toggle"
          onClick={openMobileMenu}
          aria-label="Open navigation"
        >
          <FontAwesomeIcon icon={Bars} />
        </div>
      )}
      {/* Outside the rail: the logo and the toggle are the navy end of the top bar, and
          stay put while the menu slides away underneath them. */}
      <div id="logo-bar">
        <span id="logo">
          <img
            alt="Jonas Sports"
            src={process.env.PUBLIC_URL + "/jonas-sports-logo-reversed.svg"}
          />
        </span>
        <button
          id="menu-toggle"
          type="button"
          role="switch"
          aria-checked={menuOpen}
          aria-label="Show the menu"
          title={menuOpen ? "Hide the menu" : "Show the menu"}
          onClick={toggleMenu}
        >
          <span id="menu-toggle-knob" />
        </button>
      </div>
      <nav
        id="sidebar"
        className={classNames(
          "navbar d-md-block",
          menuOpen ? "sidebar-expanded" : "",
          mobileMenuOpen ? "mobile-open" : ""
        )}
      >
        {/* Rendered whether or not it is open, so it slides out with its contents
            rather than emptying first. */}
        <Navigation
          display={expandedSectionId}
          navigationItems={menuItems}
          subDisplay={expandedSubSectionId}
          toggleDisplay={toggleSection}
          toggleSubDisplay={toggleSubSection}
        />
        {mobileMenuOpen && (
          <>
            <span id="mobile-sidebar-logo">
              <img
                alt="Jonas Sports"
                src={process.env.PUBLIC_URL + "/jonas-sports-logo-reversed.svg"}
              />
            </span>
            <div
              id="mobile-sidebar-close"
              onClick={closeMobileMenu}
              aria-label="Close navigation"
            >
              <FontAwesomeIcon icon={CrossIcon} />
            </div>
          </>
        )}
      </nav>
      {mobileMenuOpen && (
        <div id="sidebar-backdrop" onClick={closeMobileMenu} />
      )}
    </>
  );
}

export default PageMenu;
